import { useState, useEffect } from 'react';
import utils from '../helpers/FunctionsHelpers';

export default function useToken(SESSION_INTERVAL) {
  const getToken = () => {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
  };

  const [token, setToken] = useState(getToken());

  const setSessionTimeout = () => {
    utils.setSessionTimeout();
  }

  const saveToken = userToken => {
    sessionStorage.setItem('token', JSON.stringify(userToken));

    // Salva o site
    if (userToken.user.sites_id > 0) {
      sessionStorage.setItem('site_id', userToken.user.sites_id);
    }

    setToken(userToken.token);
    setSessionTimeout();
  };

  useEffect(() => {
    // Configura o timeout da sessão sempre que a página é recarregada
    if (token) {
      setSessionTimeout();
    }
  }, [token]);

  return {
    setToken: saveToken,
    token,
    setSessionTimeout
  }
}